import React from "react";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, AppBar, Toolbar, IconButton, Typography, Slide, DialogContent } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";

//store
import * as actions from "../../../../store/actions/actionIndex";

import PreviousCommentsLists from "./PreviousCommentsLists";

const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
	},
	title: {
		marginInlineStart: theme.spacing(2),
		flex: 1,
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function PreviousComments(props) {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);

	const { agentId, leadId, sessionId, onLeadComments } = props;
	React.useEffect(
		() => {
			onLeadComments(agentId, leadId);
		},
		[agentId, leadId, sessionId, onLeadComments],
		[]
	);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	let comments = Array.from(props.comments);

	return (
		<span>
			<Button variant="outlined" size="small" onClick={handleClickOpen} style={{ textTransform: "capitalize", color: "#ffffff", border: "1px solid #ffffff", marginInlineStart: "10px" }}>
				Previous Comments
			</Button>
			<Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							Previous Comments
						</Typography>
					</Toolbar>
				</AppBar>
				<DialogContent>{comments.length ? comments.map((item, index) => <PreviousCommentsLists key={index} name={item.name} time={item.time} comment={item.comment} disposition={item.disposition} subdisposition={item.subdisposition} status={item.status} />) : ""}</DialogContent>
			</Dialog>
		</span>
	);
}

const mapStateToProps = (state) => {
	return {
		error: state.callDisp.error,
		loading: state.callDisp.loading,
		custPhone: state.agentData.custPhone,
		leadId: state.agentData.leadId,
		sessionId: state.agentData.sessionId,
		agentState: state.agentData.agentState,
		agentId: state.agentData.agentId,
		facilityConf: state.agentConfig.facilityConf,
		campConf: state.agentConfig.campConf,
		comments: state.leadComment.comments,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onLeadComments: (agentId, leadId) => dispatch(actions.leadComment(agentId, leadId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviousComments);
